// extracted by mini-css-extract-plugin
export default {"SelectedFiltersList":"ClV1d8GWGDl2k_XOvniA","Item":"pHqyHjkfKrGRcrEDP9U8","FilterValue":"Ia2GDfOlpYgE97snh9TQ","IconRemove":"MAkcLxPZ8pcUol1zYb0N"};